export default __webpack_public_path__ + "a2db13bfcf89127ca258c2a4f2d97caf.svg";